import React from 'react';
import { Outlet } from "react-router-dom";
import Header from './app/header';
import Footer from './app/footer';
import { LoadingProvider } from './components/LoadingProvider';
import StoreProvider from './store/StoreProvider';
import AuthInitializer from './components/AuthInitializer';
import NotificationProvider from './components/NotificationProvider';
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

function App() {
  /* window.Pusher = Pusher;
  window.Echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.REACT_APP_REVERB_APP_KEY ?? 'qVtoLEDT7cf2i7Ob',
    wsHost: process.env.REACT_APP_REVERB_HOST ?? '127.0.0.1',
    wsPort: process.env.REACT_APP_REVERB_PORT ?? 8080,
    wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
    forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
  }); */
  return (
    <StoreProvider>
      <NotificationProvider>
        <LoadingProvider>
          <AuthInitializer />
          <Header />
          <main>
            <Outlet />
          </main>
          <Footer />
        </LoadingProvider>
      </NotificationProvider>
    </StoreProvider>
  );
}

export default App;